import React, { FC} from "react";

import { Box, Typography, Card, CardContent } from "@components/base";

interface ServiceDetailDescription {
  title: string;
  description: string;
}

const ServiceDetailDescription: FC<ServiceDetailDescription> = ({
  title,
  description,
}) => {

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" fontWeight={500}>
          {title}
        </Typography>
        <Box mt={2}>
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceDetailDescription;
